var exports = {
  "JW": "SignalStrengthIcon.module__svg___YWFsY1",
  "wL": "SignalStrengthIcon.module__green___YWFsY1",
  "D9": "SignalStrengthIcon.module__yellow___YWFsY1",
  "T_": "SignalStrengthIcon.module__orange___YWFsY1",
  "wv": "SignalStrengthIcon.module__red___YWFsY1",
  "Xe": "SignalStrengthIcon.module__tertiary___YWFsY1",
  "cQ": "SignalStrengthIcon.module__tertiaryMuted___YWFsY1",
};

module.exports = exports;
